import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Shield } from "lucide-react";

export const Footer = () => {
  const [contact, setContact] = useState("");
  useEffect(() => { api.get("/content").then((r) => setContact(r.data.about?.contact_email || "")).catch(() => {}); }, []);

  const links = [
    { to: "/about", label: "About us", id: "footer-about" },
    { to: "/disclosure", label: "Affiliate disclosure", id: "footer-disclosure" },
    { to: "/privacy", label: "Privacy policy", id: "footer-privacy" },
    { to: "/terms", label: "Booking terms", id: "footer-terms" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-20 py-12">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col lg:flex-row lg:items-start justify-between gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-[#00e5ff]" />
            <span className="display uppercase font-bold tracking-tight">GoalieHub</span>
          </div>
          <p className="text-xs text-zinc-500 mt-3 leading-relaxed">
            A marketplace for goalie coaching. GoalieHub earns a service fee on bookings made through this site —
            see our <Link to="/disclosure" className="text-[#00e5ff] hover:underline">affiliate disclosure</Link>.
          </p>
          {contact && <p className="text-xs text-zinc-500 mt-3">{contact}</p>}
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-3">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={l.id}
              className="text-[11px] uppercase tracking-widest text-zinc-400 hover:text-[#00e5ff] transition-colors duration-200">
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};
